import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { AliquotTax } from '../../model/aliquot-tax';
import { TaxType } from '../../model/tax-type';

@Injectable({
  providedIn: 'root'
})
export class AliquotTaxService {

  constructor( private dataService: DataService ) { }

  private readonly getAliquotsTaxByPlanIdEndPoint: string = '/aliquotTax/getAliquotsTaxByPlanId/';
  private readonly getAliquotsTaxEndPoint: string = '/aliquotTax/getAliquotsTax/';
  private readonly getTaxTypesEndPoint: string = '/aliquotTax/getTaxTypes/';

  async getTaxTypes(): Promise<TaxType[]> {
    const params = { };
    return await this.dataService.get<TaxType[]>(this.getTaxTypesEndPoint, params).toPromise();
  }

  async getAliquotsTaxByPlanId(planId: number): Promise<AliquotTax[]> {
    const params = { planId: planId };
    return await this.dataService.get<AliquotTax[]>
      (this.getAliquotsTaxByPlanIdEndPoint, params).toPromise();
  }

  async getAliquotsTax(): Promise<AliquotTax[]> {
    const params = { };
    return await this.dataService.get<AliquotTax[]>(this.getAliquotsTaxEndPoint, params).toPromise();
  }
}
